import React, { Component } from "react";
import { connect } from 'react-redux';
import Swal from 'sweetalert2'
import { NavigationHeader } from "../../layout/components/navigationheader/NavigationHeader";
import { Card, Button, Row, Col, Form,} from 'react-bootstrap';
import { saveDisplayWall } from '../../../../../../../actions/sceneActions'
import { DISPLAY_WALL_SUCCESS_SAVE, SUCCESS_TEXT } from '../../../app/messageText'
import { customClass, getInitialRoute } from '../../../../../../../utils'
import { LUNCH_URL } from "../../../../../../../actions/api";


class UpdateWall extends Component {
    state = {
        selectedValue: null,
        selectedText: "Select Wall",
        save: false,
        show: false,
        buttonDis: null,
        loader: null
    }
    onWallSave = event => {
        const { param } = this.props;
        const { selectedValue, selectedText } = this.state;

        if(selectedValue){
            this.setState({buttonDis:true, loader:true })
           this.props.saveDisplayWall(param.contentMixId, param.positionID, { selectedValue, selectedText }, this.onSaveCallBack)
            }else{
            Swal.fire({
                title: 'Error',
                text: 'Please select wall!',
                type: "error",
                icon: 'error',
                showConfirmButton: false,
                timer: 3000
            })
        }
    }
    onSelectDropDown = (name, value) => event => {
        this.setState({ selectedText: name, selectedValue: value })
        // this.setState({ selectedText: event.currentTarget.textContent, selectedValue: value })
    }
    onBack = event => {
        const { params } = this.props.match;
        const { selectedValue, selectedText } = this.state;
        if (selectedValue) {
            Swal.fire({
                title: "Are you sure?",
                text: "Your changes have not been saved. Do you want to save before you leave the page?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Save",
                cancelButtonText: "Discard Changes",
                reverseButtons: true,
                customClass: customClass
            }).then((result) => {
                if (result.value) {
                    const { param } = this.props;
                    const { selectedValue, selectedText } = this.state;
                    this.onWallSave()
                }
                else if (result.dismiss === "cancel") {
                    this.props.history(`/studio/${params.wallId}`)
                }
            });
        }
        else {
            this.props.history(`/studio/${params.wallId}`)
        }

    }
    onSaveCallBack = () => {
        const { params } = this.props.match;
        Swal.fire({
            title: SUCCESS_TEXT,
            text: DISPLAY_WALL_SUCCESS_SAVE,
            type: "success",
            icon: 'success',
            showConfirmButton: false,
            timer: 3000
        })

        this.setState({buttonDis:false, loader:false })
        this.props.history(`/studio/${params.wallId}`)
    }

    render() {
        const { studioWall, match } = this.props;
        const { selectedText, selectedValue,buttonDis,loader } = this.state;
        return <div>
            <NavigationHeader name="Display Wall" backToNavigation={`/studio/${match.params.wallId}`} />
            <div className="container-fluid subheader_content">
                <Card className="select_wall mb-3 rounded-0 border-0">
                    <Card.Body className="p-0">
                        <Row>
                            <Col lg={4} className="border-right-lg">
                                <Card className="border-0 rounded-0">
                                    <Card.Body className="p-4 card_height">
                                        <Form>

                                            {
                                                <Form.Group className="form-group" controlId="formBasicEmail">
                                                    <Form.Label>Select Wall </Form.Label>
                                                    {(studioWall && studioWall.walls) && <div>
                                                        {
                                                            studioWall.walls.map((item, indexID) => <div onClick={this.onSelectDropDown(item.name, item.id)} className={`d-flex flex-wrap border justify-content-between p-4 mb-4 cursor-pointer rounded${selectedText == item.name ? ' border-primary' : ''}`}>
                                                                <div className="radio-inline">
                                                                    <label className="radio radio-primary text-dark font-size-lg font-weight-bold">
                                                                        <input type="radio" name="radios12" value={item.url} checked={selectedText == item.name} />
                                                                        <span></span>
                                                                        {item.name}
                                                                    </label>
                                                                </div>
                                                                <span className="text-muted font-weight-bolder">{item.postCount}</span>

                                                            </div>)
                                                        }
                                                    </div>}
                                                </Form.Group>
                                            }
                                         
                                        </Form>
                                    </Card.Body>
                                    <Card.Footer className="bg-transparent d-flex justify-content-end border-0 p-4">
                                        <button className="btn btn-outline-dark me-3 btn-min-w" onClick={this.onBack}><span className="position-relative">Back</span></button>
                                        <Button variant="primary" disabled={ buttonDis } className={`btn btn-primary btn-min-w ${loader ? `spinner spinner-white spinner-right disabled` : null}`}  onClick={this.onWallSave}>Save</Button>
                                    </Card.Footer>
                                </Card>
                            </Col>
                            <Col lg={8} className="d-flex align-items-center justify-content-center">
                                <Card className="border-0 card w-100">
                                    <Card.Body className="border-0">
                                        <div className="wall_view">
                                            <div className="wall_view_wrapper">
                                                {
                                                    selectedValue != null ? <iframe className="preview-display-wall preview-display-wall-iframe" src={`${LUNCH_URL}${selectedValue}?editor&studio=1`} style={{ maxWidth: '100%', maxHeight: '100%', display: 'block' }}></iframe> : ''
                                                }
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                    </Card.Body>
                </Card>
            </div>
        </div>
    }

}
const mapStateToProps = state => {
    return {
        studioWall: state.studio.studioWall
    }
}
const mapDispatchToProps = dispatch => {
    return {
        saveDisplayWall: (contentMixId, positionID, wall, callBack) => dispatch(saveDisplayWall(contentMixId, positionID, wall, callBack)),
    }
}




export default connect(mapStateToProps, mapDispatchToProps)(UpdateWall);